<template>
  <div class="rechargeAndPaymentOrder">

    <!-- 内容 -->
    <div class="orderCon">
      <!-- 标题 -->
      <Title-Box :top-title="topTitle"></Title-Box>

      <!-- 订单搜索 -->
      <!-- tab角色管理-筛选框 -->
      <sr-filter class="orderSearch2" @search="handleSearch" @reset="handleReset">
        <template slot="otherCom">
            <el-form-item>
                <el-input v-model="search.order_id" placeholder="请输入订单编号" class="outInput" maxlength="30" size="medium" clearable></el-input>
            </el-form-item>

            <el-form-item>
                <el-input v-model="search.goods_name" placeholder="请输入商品名称" class="outInput" maxlength="30" size="medium" clearable></el-input>
            </el-form-item>

            <el-form-item>
                <el-select v-model="search.recharge_payment_way" @change="handleSearch" placeholder="选择充值缴费类型" size="medium" clearable filterable>
                    <!-- <el-option v-for="item in rechargePaymentWayOptions" :key="item.key" :label="item.label" :value="item.key"></el-option> -->
                    <el-option label="全部" value=""></el-option>
                    <el-option label="充值缴费1" value="0"></el-option>
                    <el-option label="充值缴费2" value="1"></el-option>
                </el-select>
            </el-form-item>

            <!-- <el-form-item>
                <el-input v-model="search.buyer_name" placeholder="请输入买家姓名" class="outInput" maxlength="30" size="medium" clearable></el-input>
            </el-form-item> -->

            <el-form-item>
                <el-date-picker
                  type="datetime"
                  v-model="search.begin_time"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="medium"
                  class="timeStyle"
                  placeholder="请选择开始时间">
                </el-date-picker>
                &nbsp;至&nbsp;
                <el-date-picker
                  type="datetime"
                  v-model="search.end_time"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="medium"
                  class="timeStyle"
                  placeholder="请选择截止时间">
                </el-date-picker>
            </el-form-item>

        </template>
      </sr-filter>

      <!-- 类型切换 -->
      <ul class="tabType clearfix">
        <li v-for="(item,index) in orderStatus.textArr"
            @click="changeStatus(item, index)"
            :class="{on:orderStatus.nowIndex==index}"
        >
          {{item.name}}
        </li>
      </ul>

      <!-- 订单列表 -->
      <div class="orderList">
        <!-- 标题 -->
        <div class="titBox flex-row jus-b boxs ite-c">
          <b>订单列表</b>
          <button @click="exportData" class="pinkBtn butStyle exportBtn">
            <i class="icon export"></i>
            <span>导出</span>
          </button>
        </div>

        <!-- 列表头部信息 -->
        <ul class="listHander clearfix">
          <li>运营商品</li>
          <li>单价</li>
          <li>数量</li>
          <li>买家</li>
          <li>充值/缴费类型</li>
          <li>订单状态</li>
          <li>实收款</li>
          <li>备注</li>
        </ul>

        <p v-if="orderData.length == 0" class="zoreData">暂无数据</p>

        <template v-if="orderData.length > 0">
          <!-- 订单列表 -->
          <div class="cartList" v-for="item in orderData">
            <!-- 订单标头 -->
            <div class="carthear flex-row jus-b boxs">
              <span class="orderNum"><b>订单号：</b>{{item.order_id}}</span>
              <span class="payType"><b>支付方式：</b>{{item.pay_method}}</span>
              <span class="payNum"><b>支付流水号：</b>{{item.pay_out_no}}</span>
              <span class="payTime"><b>下单时间：</b>{{item.create_time}}</span>
            </div>

            <!-- 订单内容 -->
            <div class="cartCon flex-row boxs">
              <!-- 运营商品 -->
              <div class="cartDetail boxs">
                <ul class="detailList boxs" v-for="sku in item.skus">
                  <li class="boxs flex-row">
                    <img :src="$baseUrl + '/' + sku.pic_url" alt="">
                    <div class="cartInfo flex-col jus-b">
                      <p class="detail-tit">{{sku.goods_title}}</p>
                      <p>{{sku.goods_operator}}</p>
                    </div>
                  </li>
                  <!-- 单价 -->
                  <li>￥{{sku.sku_price}}</li>
                  <!-- 数量 -->
                  <li>{{sku.sku_quantity}}</li>
                </ul>
              </div>
              <!-- 买家 -->
              <div class="buyer flex-col jus-c ite-c">
                <p class="name">{{item.buyer_name}}</p> <br/>
                <p class="phoneNum">{{item.buyer_phone || '-'}}</p>
              </div>
              <!-- 充值缴费类型 -->
              <div class="takeCardWay flex-col jus-c ite-c">
                <p class="name">{{item.recharge_payment_way}}</p>
              </div>
              <!-- 订单状态 -->
              <div class="orderState flex-col jus-c ite-c">
                <p class="wait">{{item.status_name}}</p>


                <!-- 待支付 -->
                <template v-if="item.status_code == 1">
                  <button @click="toggleLayer(4, item)" class="butStyle upPriceBtn orangeBtn">修改价格</button>
                  <button @click="toggleLayer(2, item)" class="butStyle closeBtn pinkBtn">关闭订单</button>
                </template>


                <!-- 已完成 无任何操作 -->
                <template v-if="item.status_code == 2">
                </template>

                <!-- 已关闭 无任何操作 -->
                <template v-if="item.status_code == 3">
                </template>

                <!-- 已取消 无任何操作 -->
                <!--<template v-if="item.status_code == 4">-->
                <!-- </template> -->

                <a @click="toDetail(item)" class="orderDetail">订单详情</a>

              </div>
              <!-- 实收款 -->
              <div class="orderTotal flex-col jus-c ite-c">
                <p class="price">￥{{item.price_real}}</p> <br/>
                <p class="phoneNum">(运费：￥{{item.price_logistics}})</p>
              </div>
              <!-- 备注 -->
              <div class="remarks flex-row ite-c">{{item.order_note}}</div>
            </div>
          </div>
        </template>
        <!-- 分页 -->
        <div class="Listpage flex-row ite-c">
          <el-pagination 
                        background
                        :page-sizes="[10, 20, 30]" 
                        layout="total, sizes, prev, pager, next, jumper" 
                        @size-change="handleSizeChange" 
                        @current-change="handleCurrentChange"
                        :page-size="search.pageSize"
                        :current-page="search.page" 
                        :total="total">
            </el-pagination>
        </div>
        <!-- 分页(简单) -->
        <!-- <div class="Listpage flex-row ite-c">
          <el-pagination
                  background
                  layout="total, prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="search.pagesize"
                  :current-page="search.page"
                  :total="total">
          </el-pagination>
        </div> -->

      </div>
    </div>


    <!-- 发货 -->
    <send @cancel="showSend = false"
          @confirm="handleSendConfirm"
          :order-item="currentOrderItem"
          v-if="showSend">
    </send>

    <!--关闭订单-->
    <close-order
            @cancel="showCloseOrder = false"
            @confirm="handleCloseOrderConfirm"
            v-if="showCloseOrder"></close-order>

    <!-- 延迟收货时间 -->
    <delay-time
            @cancel="showDelayTime = false"
            @confirm="handleDelayTimeConfirm"
            v-if="showDelayTime">
    </delay-time>

    <!-- 修改价格 -->
    <up-data-price @confirm="handleUpdatePriceConfirm"
                   @cancel="showUpdatePrice = false" :order-item="currentOrderItem"
                   v-if="showUpdatePrice">
    </up-data-price>

  </div>
</template>

<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import SrFilter from '@/components/Common/Filter/Filter';

  import closeOrder from '@/views/Order/Common/CloseOrder';
  import delayTime from '@/views/Order/Common/DelayTime';
  import upDataPrice from '@/views/Order/Common/UpDataPrice';
  import send from '@/views/Order/Common/Send';
  // import UpdateLogistics from '@/views/Order/Common/UpdateLogistics';
  import {objectToQueryString} from '@/utils/commonUtils.js';
  import {yuanToCents, centsToYuan} from '@/utils/unitConverter.js';
  import {
    getOrderListReq, //请求订单数据
    deliverGoodsReq, //发货
    closeOrderReq, //关闭订单
    extendReceiptTimeReq, //延长收货时间
    modifyPriceReq //修改价格
  } from "@/api/Order/NumCardOrder/sceneBuyCardOrder.js";

  // 搜索条件-筛选栏
  const defaultSearch = {
      order_id: "",
      goods_name: "",
      recharge_payment_way: "", //充值缴费类型
      begin_time: undefined,
      end_time: undefined,
      status: undefined, //订单状态(待支付、已完成、已关闭、已取消、全部)
      page: 1, //当前页码
      pagesize: 10, //每页数据数量
  }

  export default {
    name: "rechargeAndPaymentOrder",
    data() {
      return {
        //标题
        topTitle: {
          title: '充值/缴费订单',
          subTit: ''
        },
        // 订单状态
        orderStatus: {
          textArr: [
            {
              name: '待支付',
              value: 1
            }, {
              name: '已完成',
              value: 2
            }, {
              name: '已关闭',
              value: 3
            }, {
              name: '已取消',
              value: 4
            }, {
              name: '全部',
              value: undefined
            },
          ],
          nowIndex: 0
        },
        
        // 表格搜索条件
        search: Object.assign({}, defaultSearch),
        operatorOptions: [
          { id: '1', name: '运营商1' },
          { id: '2', name: '运营商2' },
          { id: '3', name: '运营商3' },
          { id: '4', name: '运营商4' },
        ],
        searchCache: {},
        //订单数据
        orderData: [],
        //订单总数量
        total: 0,
        
        // 当前操作的订单
        currentOrderItem: {},
        showSend: false,
        showUpdatePrice: false,
        showDelayTime: false,
        showCloseOrder: false,
      }
    },
    created() {
      this.getOrders();
    },
    methods: {
      // 导出
      exportData() {
        // window.open(`${this.$baseUrl}/!Front/Order/~query/BUSI_GOODS_ORDER_QUERY.EXPORT_ORDER?_exeresult=excel&${objectToQueryString(this.search)}`, '_blank');
        // window.open(`${this.$baseUrl}/【导出接口】?_exeresult=excel&${objectToQueryString(this.search)}`, '_blank');
      },
      // 前往订单详情页
      toDetail(item) {
        this.$router.push({path: 'rechargeAndPaymentOrderDetail', query: {id: item.order_id}})
      },
      
      // 切换订单状态
      changeStatus(item, idx) {
        this.search.status = item.value
        this.orderStatus.nowIndex = idx
        this.getOrders();
      },
      //请求订单数据
      getOrders() {
        // // this.searchCache = JSON.parse(JSON.stringify(this.search))
        // getOrderListReq(this.search)
        //     .then(res => {
        //       // this.callBack(res.body);
        //       const data = res.body
        //       this.total = data.total - 0;//订单总数量
        //       this.orderData = data.rows;//订单列表
        //     })
        //     .catch(e => console.log(e));

        this.orderData = [
          {
            order_id: 'D2018062700095048', //订单号：
            pay_method: '支付宝支付', //支付方式：
            pay_out_no: '201809099090909780', //支付流水号：
            create_time: '2018/09/07 04:02', //下单时间：

            skus: [
              {
                pic_url: '', //运营商品-图片
                goods_title: '4G不限量', //运营商品-名称
                goods_operator: '中国联通', //运营商品-运营商

                sku_price: '24', //单价
                sku_quantity: '1', //数量
              }
            ],

            buyer_name: '里斯', //买家
            buyer_phone: '1881245511', //买家号码？

            recharge_payment_way: '套餐续订', //充值缴费类型

            status_name: '待支付', //订单状态
            status_code: '1', //订单状态:1待支付、2已完成、3已关闭、 4已取消
            
            price_real: '100.00', //实收款
            price_logistics: '0.00', //实收款-运费

            order_note: '', //备注
          },
          {
            order_id: 'D2018062700095048', //订单号：
            pay_method: '支付宝支付', //支付方式：
            pay_out_no: '201809099090909780', //支付流水号：
            create_time: '2018/09/07 04:02', //下单时间：

            skus: [
              {
                pic_url: '', //运营商品-图片
                goods_title: '4G不限量', //运营商品-名称
                goods_operator: '中国联通', //运营商品-运营商

                sku_price: '24', //单价
                sku_quantity: '1', //数量
              }
            ],

            buyer_name: '里斯', //买家
            buyer_phone: '1881245511', //买家号码？

            recharge_payment_way: '充值', //充值缴费类型

            status_name: '已取消', //订单状态
            status_code: '4', //订单状态:1待支付、2已完成、3已关闭、 4已取消
            
            price_real: '100.00', //实收款
            price_logistics: '0.00', //实收款-运费

            order_note: '', //备注
          },
          {
            order_id: 'D2018062700095048', //订单号：
            pay_method: '支付宝支付', //支付方式：
            pay_out_no: '201809099090909780', //支付流水号：
            create_time: '2018/09/07 04:02', //下单时间：

            skus: [
              {
                pic_url: '', //运营商品-图片
                goods_title: '4G不限量', //运营商品-名称
                goods_operator: '中国联通', //运营商品-运营商

                sku_price: '24', //单价
                sku_quantity: '1', //数量
              }
            ],

            buyer_name: '里斯', //买家
            buyer_phone: '1881245511', //买家号码？

            recharge_payment_way: '购叠加包', //充值缴费类型

            status_name: '已完成', //订单状态
            status_code: '2', //订单状态:1待支付、2已完成、3已关闭、 4已取消
            
            price_real: '100.00', //实收款
            price_logistics: '0.00', //实收款-运费

            order_note: '', //备注
          },
          {
            order_id: 'D2018062700095048', //订单号：
            pay_method: '支付宝支付', //支付方式：
            pay_out_no: '201809099090909780', //支付流水号：
            create_time: '2018/09/07 04:02', //下单时间：

            skus: [
              {
                pic_url: '', //运营商品-图片
                goods_title: '4G不限量', //运营商品-名称
                goods_operator: '中国联通', //运营商品-运营商

                sku_price: '24', //单价
                sku_quantity: '1', //数量
              }
            ],

            buyer_name: '里斯', //买家
            buyer_phone: '1881245511', //买家号码？

            recharge_payment_way: '充值', //充值缴费类型

            status_name: '已关闭', //订单状态
            status_code: '3', //订单状态:1待支付、2已完成、3已关闭、 4已取消
            
            price_real: '100.00', //实收款
            price_logistics: '0.00', //实收款-运费

            order_note: '', //备注
          },
        ]
      },

     

      // 重置搜索条件
      // handleReset() {
      //   const status = this.search.status
      //   this.search = {}
      //   this.search.status = status
      // },
      // 列表过滤查询(搜索)
      handleSearch() {
          this.search.page = 1
          this.getOrders()
      },
      // 重置（清空）
      handleReset() {
        const status = this.search.status
        // 初始化参数
        this.search = Object.assign({}, defaultSearch)
        this.search.status = status
        // 获取表格数据
        this.getOrders()
      },
      // 列表每页条数(数量)变了
      handleSizeChange(val) {
          this.search.pageSize = val
          this.getOrders()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
          this.search.page = val
          this.getOrders()
      },



      // 修改价格回调事件
      handleUpdatePriceConfirm(result) {
        // 数据清洗，过滤无用的请求数据
        const req_skus = result.skus.map(value => {
          return {
            id: value.sku_id,
            price_real: yuanToCents(value.price_real)
          }
        })

        const req = {
          order_skus: req_skus,
          order_id: this.currentOrderItem.order_id,
        }
        modifyPriceReq(req)
            .then(resp => {
              this.$notifySuccess(`订单[${this.currentOrderItem.order_id}]价格修改成功`);
              this.getOrders()
              this.toggleLayer(4)
            })
            .catch(e => console.log(e))
      },
      // 处理发货确认事件
      handleSendConfirm(val) {
        if (val.needLogistics == 1) {
          if (!val.express_type) {
            this.$notifyError('请选择一家物流公司');
            return;
          }
          if (!val.express_num) {
            this.$notifyError('请输入物流单号');
            return;
          }
        }

        const p = {
          order_id: val.order_id,
          express_type: val.express_type,
          express_num: val.express_num
        }
        deliverGoodsReq(p)
            .then(resp => {
              this.$notifySuccess(`订单[${this.currentOrderItem.order_id}]发货成功`);
              this.getOrders()
              this.toggleLayer(1)
            })
            .catch(e => console.log(e))
      },
      // 处理延长收货时间确认事件
      handleDelayTimeConfirm() {
        const p = {
          order_id: this.currentOrderItem.order_id,
        }
        extendReceiptTimeReq(p)
            .then(resp => {
              this.$notifySuccess(`订单[${this.currentOrderItem.order_id}]延长收货时间成功`);
              this.getOrders()
              this.toggleLayer(3)
            })
            .catch(e => console.log(e))
      },
      // 处理关闭订单确认事件
      handleCloseOrderConfirm(close_reason) {
        const p = {
          order_id: this.currentOrderItem.order_id,
          close_reason: close_reason
        }
        closeOrderReq(p)
            .then(resp => {
              this.$notifySuccess(`订单[${this.currentOrderItem.order_id}]关闭成功`);
              this.getOrders()
              this.toggleLayer(2)
            })
            .catch(e => console.log(e))
      },
      // 弹层开关
      toggleLayer(type, item) {
        this.currentOrderItem = item;
        // 1：发货 2:关闭订单 3：延长发货时间 4：更新价格
        switch (type) {
          case 1:
            this.showSend = !this.showSend
            break;
          case 2:
            this.showCloseOrder = !this.showCloseOrder
            break;
          case 3:
            this.showDelayTime = !this.showDelayTime
            break;
          case 4:
            this.showUpdatePrice = !this.showUpdatePrice
            break;
        }
      },
    },
    components: {
      TitleBox,
      SrFilter,
      closeOrder,
      delayTime,
      upDataPrice,
      send
    }
  }
</script>

<style scoped>
  .rechargeAndPaymentOrder {
    /* height: auto; */
    min-width: 890px;
  }

    /*日期切换*/
  .tabType {
    background: #fff;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-top: 18px;
  }

  .tabType li {
    float: left;
    width: 80px;
    color: #7F7F7F;
    font-size: 12px;
    cursor: pointer;
    position: relative;
  }

  .tabType li:after {
    content: '';
    position: absolute;
    width: 80px;
    height: 4px;
    background: transparent;
    bottom: -4px;
    left: 0;
  }

  .tabType li.on:after {
    background: #F99A1A;
  }

  .orderSearch2 {
    margin-top: 1px;
  }
  
  .orderSearch {
    margin-top: 1px;
    height: 68px;
    background: #fff;
  }

  .orderSearch .le-box {
    padding-left: 14px;
  }

  .le-box .outInput {
    width: 25%;
    max-width: 260px;
    margin-right: 24px;
  }

  .ri-box {
    padding-right: 14px;
  }

  /* 遮罩 */
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    /*background: rgba(0,0,0,0.5);*/
    z-index: 99;
  }

  .orderList {
    margin-top: 18px;
  }

  .titBox {
    padding: 0 16px 0 12px;
    background: #fff;
    height: 44px;
    line-height: 44px;
  }

  .titBox b {
    font-size: 13px;
  }

  .exportBtn {
    width: 80px;
    height: 30px;
    line-height: 30px;
  }

  .exportBtn i {
    vertical-align: middle;
  }

  /* 订单信息头 */
  .listHander {
    background: #7F7F7F;
    font-size: 12px;
  }

  .listHander li {
    float: left;
    width: 9.5%;
    height: 28px;
    line-height: 28px;
    text-align: center;
    font-weight: bold;
    color: #fff;
  }

  .listHander li:nth-child(1) {
    /* width: 33%; */
    width: 31.1%;
  }
  .listHander li:nth-child(2) {
    /* width: 9.5%; */
    width: 7%;
  }
  .listHander li:nth-child(3) {
    /* width: 6.4%; */
    width: 5.8%;
  }
  .listHander li:nth-child(4) {
    width: 8.8%;
  }
  .listHander li:nth-child(5) {
    /* width: 6.4%; */
    width: 5.8%;
  }
  .listHander li:nth-child(6) {
    /* width: 12.8%; */
    width: 11.6%;
  }
  .listHander li:nth-child(7) {
    /* width: 10%; */
    width: 9.1%;
  }
  .listHander li:nth-child(8) {
    /* width: 22.6%; */
    width: 20.6%;
  }

  /* 订单列表 */
  /* 订单标头 */
  .carthear {
    font-size: 12px;
    color: #2B2727;
    border: 1px solid #eee;
    margin-top: 10px;
    /* background: #FBFBFB; */
    background: #ffffff;
    padding: 0 11px 0 0;
  }
  .carthear {
    line-height: 36px;
    height: 36px;
    text-indent: 12px;
  }

  .carthear span.orderNum {
    color: #3289FF;
  }
  .carthear span.orderNum b {
    color: #7F7F7F;
    font-weight: normal;
  }

  .carthear span.payType {
    color: #4E4A46;
  }
  .carthear span.payType b {
    color: #7F7F7F;
    font-weight: normal;
  }

  .carthear span.payNum {
    color: #4E4A46;
  }
  .carthear span.payNum b {
    color: #7F7F7F;
    font-weight: normal;
  }

  .carthear span.payTime {
    color: #4E4A46;
  }
  .carthear span.payTime b {
    color: #7F7F7F;
    font-weight: normal;
  }

  .cartCon {
    background: #fff;
    border: 1px solid #eee;
    border-top: none;
    color: #3B3B3B;
    font-size: 12px;
  }

  .cartCon .cartDetail {
    width: 49%;
  }

  .cartCon .cartDetail .detailList {
    height: 112px;
    overflow: hidden;
    border-bottom: 1px solid #eee;
  }

  .detailList li {
    float: left;
    height: 112px;
    border-right: 1px solid #eee;
  }

  .detailList li:nth-child(1) {
    width: 69.8%;
    /* width: 67.5%; */
    padding: 13px 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .detailList li:nth-child(2) {
    width: 15.5%;
    /* width: 19.4%; */
    font-weight: bold;
  }

  .detailList li:nth-child(3) {
    width: 12.9%;
    /* width: 13.1%; */
  }

  .detailList li + li {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .detailList li:nth-child(1) img {
    width: 88px;
    height: 88px;
    background: #f9f9f9
  }

  .detailList li:nth-child(1) .cartInfo p {
    line-height: 16px;
  }
  .detailList li:nth-child(1) .cartInfo {
    width: 360px;
    height: 88px;
    font-size: 12px;
    color: #999;
    margin-left: 8px;
  }

  .cartInfo .detail-tit {
    /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;  */
    /* autoprefixer: off */
    /* autoprefixer: on */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333333;
    margin-bottom: 3px;
  }
  .cartInfo .detail-phone {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333333;
    margin-bottom: 13px;
  }
  .cartInfo .detail-busi span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333333;
    margin-bottom: 4px;
  }

    /* 8.8145 
    6.4105
    12.821
    10.016
    11.3186
    11.3186 */
  .buyer {
    width: 8.8%;
    /* width: 8.6%; */
    text-align: center;
    border-right: 1px solid #eee;
    color: #B7B2AF;
  }
  .buyer .name {
    color: #2DBAA5;
  }
  .buyer .phoneNum {
    color: #B7B2AF;
  }

  .takeCardWay {
    width: 6.4%;
    text-align: center;
    border-right: 1px solid #eee;
    color: #2B2727;
  }

  .orderTotal {
    width: 10%;
    text-align: center;
    border-right: 1px solid #eee;
    color: #B7B2AF;
  }
  .orderTotal .price {
    font-size: 12px;
    color: #DF0000;
  }


  .remarks {
    width: 22.6%;
    text-align: center;
  }

  /* 订单状态 按键 */
  .orderState {
    width: 12.8%;
    font-size: 12px;
    color: #666;
    border-right: 1px solid #eee;
  }

  .wait {
    font-size: 13px;
    font-weight: bold;
    color: #3B3B3B;
  }

  .orderDetail {
    margin-top: 5px;
    cursor: pointer;
    color: #2DBAA5;
  }

  .sendBtn, .closeBtn, .upPriceBtn {
    width: 72px;
    height: 24px;
    line-height: 24px;
    -webkit-border-radius: 39px;
    -moz-border-radius: 39px;
    border-radius: 39px;
  }

  .timeBtn {
    width: 94px;
    height: 24px;
    line-height: 24px;
    -webkit-border-radius: 39px;
    -moz-border-radius: 39px;
    border-radius: 39px;
  }

  .butStyle {
    margin-top: 5px;
  }

  .timeStyle {
    width: 21%;
  }

  /* 分页 */
  .Listpage {
    height: 52px;
    margin-top: 14px;
    background: #fff;
    justify-content: flex-end;
  }
</style>
